import { useHistory } from 'react-router';
import { addQueryParam, debounce } from '../../../lib/utils';
import { UserPageBarCombinedProps } from './types';

const usePresenter = (props: UserPageBarCombinedProps): UserPageBarCombinedProps => {
  const history = useHistory();
  const { page, perPage, totalPages, totalItems } = props;

  const handleTextChange = (value: string) => {
    const newPage = Number(value) || 1;
    const params = addQueryParam(history.location.search, {
      page: `${newPage}`,
    });

    history.push({
      search: params,
    });
  };

  const debouncedHandleTextChange = debounce(handleTextChange, 500);
  
  return {
    ...props,
    showingLabel: {
      value: `${perPage} per page out of ${totalItems || ''} (${totalPages || ''} pages)`,
    },
    previousPage: {
      disabled: (page || 0) < 2,
      icon: {
        asset: 'ChevronLeft',
      },
      onClick: () => {
        const params = addQueryParam(history.location.search, {
          page: `${(page || 1) - 1}`,
        });

        history.push({
          search: params,
        });
      },
    },
    pageIndicator: {
      textValue: `${page}`,
      onTextChanged: (value: string) => debouncedHandleTextChange(value),
    },
    nextPage: {
      icon: {
        asset: 'ChevronRight',
      },
      onClick: () => {
        const params = addQueryParam(history.location.search, {
          page: `${(page || 1) + 1}`,
        });

        history.push({
          search: params,
        });
      },
    },
  };
};

export default usePresenter;
